export default __webpack_public_path__ + "static/media/car.a0e50ef2.png";